import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { OrderMealEntree, Menu, BasicOrderMealItemWithContents, BasicOrderMealItem, OrderMealItem } from '@/models';
import { COUNTRIES_TAX_INCLUSIVE, CountryCode } from '@/store/ui';

@Component({
  name: 'CmgEntreeCard',
})
export default class CmgEntreeCard extends Vue {
  @Prop({ required: true })
  public entree!: OrderMealEntree;

  @Prop({ required: true })
  public sidesAndDrinks!: BasicOrderMealItem[];

  get formattedEntree(): string {
    if (!this.menu) {
      return '';
    }

    return this.getFormattedDetails(this.entree, this.menu);
  }
  
  get isTaxInclusiveCountry(): boolean {
    const taxInclusiveIndex = COUNTRIES_TAX_INCLUSIVE.findIndex(item => new RegExp(this.$appStore.state.ui.countryProfile.countryCode, 'i').test(item));
    return taxInclusiveIndex >= 0;
  }

  get entreePrice(): string {
    return this.$services.utils.formatPrice(this.isTaxInclusiveCountry ? (this.entree.entreeTotalAmount + this.entree.entreeDiscountAmount) : this.entree.entreeExtendedPrice);
  }

  get menu(): Menu | null {
    return this.$appStore.state.menu.activeMenu;
  }
  
  formatPrice(item: OrderMealItem): string {
    return this.$services.utils.formatPrice(this.isTaxInclusiveCountry ? (item.itemTotalAmount + item.itemDiscountAmount) : item.itemExtendedPrice);
  }

  getFormattedDetails(orderEntree: BasicOrderMealItemWithContents, menu: Menu) {
    return this.$services.entree.getFormattedDetails(orderEntree, menu);
  }
}
